import styled from 'styled-components';
import IconButton from '@mui/material/IconButton';
import * as Cards from 'eCoach/_styles/Cards.style';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Text from 'theme/components/Text.style';

interface SectionProps {
  eCoach?: boolean;
}

interface SubmitButtonProps {
  disabled?: boolean;
}

export const ChatBubble = styled(Cards.Card)`
  p {
    color: black;
  }
`;

export const Label = styled(Text.P2Semibold)``;

export const Section = styled('div')<SectionProps>`
  align-items: ${(props) => (props.eCoach ? 'flex-start' : 'flex-end')};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 0;
  width: 100%;
`;

// ecoach chat styles

export const ECoachMessage = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-left: 25px;
  width: fit-content;

  p {
    color: black;
  }
`;

export const Headers = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

// user chat styles

export const EditInputSection = styled('div')`
  align-items: flex-end;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const UserMessage = styled(Cards.Card)`
  border: 0.5px solid ${colours.neutral[100]};
  border-radius: 20px;
  box-shadow: unset;
  gap: 10px;
  padding: 30px;
  width: fit-content;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 20px;
  }
`;

export const DescriptionText = styled(Text.P2)`
  white-space: pre-line;
`;

export const ButtonArea = styled('div')`
  display: flex;
  justify-content: flex-end;
`;

export const SubmitButton = styled(IconButton)<SubmitButtonProps>`
  background-color: ${colours.primary[500]};
  border-radius: 10px;

  &:hover {
    background-color: ${colours.primary[500]};
  }
  svg path {
    stroke: ${(props) => (props.disabled ? colours.neutral[300] : 'white')};
  }
`;

export const LogoText = styled('img')`
  box-sizing: unset;
  height: 18px;
  max-width: 82px;
  width: fit-content;
`;
